"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortedValue = exports.getSliderValueFromPercent = exports.getSliderValue = exports.getIsMarkerInRange = exports.getDecimalPlaces = void 0;
const getDecimalPlaces = (num) => {
    var _a;
    const numStr = num.toString();
    if (numStr.includes(".")) {
        return (_a = numStr.split(".")[1]) === null || _a === void 0 ? void 0 : _a.length;
    }
    return 0;
};
exports.getDecimalPlaces = getDecimalPlaces;
const getIsMarkerInRange = (value, min, max, step, stepIndex) => {
    const markerPosition = step * stepIndex + min;
    if (stepIndex < 0 || markerPosition > max) {
        return false;
    }
    return markerPosition >= value[0] && markerPosition <= value[1];
};
exports.getIsMarkerInRange = getIsMarkerInRange;
const getSliderValue = (value, max, min, slider) => {
    const valueBounded = Math.max(min, Math.min(max, value));
    const valueStepped = Math.round(valueBounded / slider.step) * slider.step;
    const stepDecimalPlaces = (0, exports.getDecimalPlaces)(slider.step);
    const valueDecimaled = valueStepped.toFixed(stepDecimalPlaces);
    return Number(valueDecimaled);
};
exports.getSliderValue = getSliderValue;
const getSliderValueFromPercent = (percent, max, min, slider) => {
    const value = percent * (slider.max - slider.min) + slider.min;
    return Number((0, exports.getSliderValue)(value, max, min, slider));
};
exports.getSliderValueFromPercent = getSliderValueFromPercent;
const getSortedValue = (value) => {
    return value.sort((prev, next) => prev - next);
};
exports.getSortedValue = getSortedValue;
//# sourceMappingURL=helpers.js.map